import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'res-info-panel',
    templateUrl: './info-panel.component.html',
    styles: [
    ]
})
export class InfoPanelComponent implements OnInit {

    @Input() i18nKey: string;

    @Input() target: string;
    public infoHeader: string;
    public infoMessage: string;

    ngOnInit(): void {
        let prefix = this.i18nKey.replace('.common.', '.' + this.target + '.').replace('.tab', '');
        this.infoHeader = 'fs.res.common.infoHeader';
        this.infoMessage = prefix + '.infoMessage';
    }

}
